import { useContext, useState, useEffect } from "react";
import Sidebar from "../sidebar/Sidebar";
import Nav from "../nav/Nav";
import Dashboard from "../fuselage/dashboard/Dashboard";
import Entries from "../fuselage/entries/Entries";
import Management from "../fuselage/management/management";
import { Route, Routes } from "react-router-dom";
import AddStation from "../fuselage/management/addStation";
import AddAgent from "../fuselage/management/addAgent";
import EditStation from "../fuselage/management/editStation";
import EditAgent from "../fuselage/management/editAgent";
import Settings from "../fuselage/settings";
import SocialChannels from "../fuselage/socialChannels";
import Channel from "../fuselage/socialChannels/channels";
import Reports from "../fuselage/reports";
import Insights from "../fuselage/Insights";
import Insights2 from "../fuselage/Insights2";
import Survey from "./Survey";
import SurveyResponse from "../fuselage/survey";
import CampaignContext from "../../contexts/CampaignContext";
import LeaderboardPage from "../fuselage/entries/leaderboard";

const cId = "63482f0c29b3cba922b53dbb";
const Core = () => {
  const [campaign, setCampaign] = useContext(CampaignContext);
  const [campaignId, setCampaignId] = useState("");

  useEffect(() => {
    const currentCampaign = JSON.parse(sessionStorage.getItem("CAMPAIGN"));

    setCampaignId(currentCampaign.id);
  }, [campaign]);

  const toggleNav = () => {
    const sidebar = document.getElementById("mobileSideBar");
    sidebar.classList.toggle("-translate-x-full");
    document.body.classList.toggle("overflow-hidden");
  };
  return (
    <div>
      <div className="lg:grid lg:grid-cols-6 md:h-screen overflow-hidden bg-[#FFFDFB]">
        <div className="hidden lg:block col-span-1">
          <Sidebar />
        </div>
        <div className="col-span-5 overflow-auto">
          <div className="sticky z-50 top-0">
            <Nav />
          </div>

          <div
            id="mobileSideBar"
            className="lg:hidden h-screen transition-all duration-700 ease-in-out fixed bg-[#00000050]  z-50 -translate-x-full top-0  w-full overflow-hidden"
          >
            <div className="flex h-full w-full">
              <div className="w-9/12 bg-white">
                <div className="w-11/12">
                  <Sidebar />
                </div>
              </div>
              <div
                className="flex-1"
                aria-roledescription="close-nav"
                role="button"
                tabIndex="0"
                onKeyDown={() => toggleNav()}
                onClick={() => toggleNav()}
              >
                <div className="text-center my-8">
                  <button className="mx-auto" onClick={() => toggleNav()}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="white"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-10 md:pt-16 md:mt-2 h-full ">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/survey-response" element={<SurveyResponse />} />
              <Route path="/entries" element={<Entries />} />
              <Route path="/leaderboard" element={<LeaderboardPage />} />
              <Route path="/management/add-station" element={<AddStation />} />
              <Route path="/management/add-agent" element={<AddAgent />} />
              <Route
                path="/management/edit-agent/:id"
                element={<EditAgent />}
              />
              <Route
                path="/management/edit-station/:id"
                element={<EditStation />}
              />
              <Route path="/management/*" element={<Management />} />
              {/* ::::   Social channels  :::::: */}
              <Route path="/social-channels" element={<SocialChannels />} />
              <Route path="/social-channels/:id" element={<Channel />} />
              {/* ::: Reports :::: */}
              <Route path="reports" element={<Reports />} />
              {/* {campaignId === cId ? ( */}
              <Route path="insights" element={<Insights2 />} />
              {/* // ) : (
              //   <Route path="insights" element={<Insights />} />
              // )} */}

              {/* :::::  Settings  :::: */}
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Core;

//
// <div className="row-span-1  col-span-5 min-h-0 overflow-hidden">
//     <Nav/>
// </div>
// <div className="row-span-1 col-span-5">
//     <Dashboard/>
// </div>
